import { Fragment } from 'react';

import HeroBanner from '../components/Layout/RelaunchPage/HeroBanner';

import { Grid, Typography, Box } from '@mui/material';

const RelaunchPage = () => {
  return (
    <Fragment>
      <Grid display='flex' direction='column' alignItems='center' justifyContent='center'>
        <HeroBanner />
        <Box
          sx={{
            width: { lg: 'min(900px, 60vw)' },
          }}>
          <Typography variant='body1' sx={{ fontWeight: 'regular', mb: '1rem' }}>
            The 100 Club v1.5 has arrived.
            <br></br>
            <br></br>
            Our vision has always been to help founders build a robust peer support system as Singapore’s leading
            mastermind community. Which is why over the past few months, we have been listening to your feedback.
            Through your sharings, we now bring you the same 100 Club that you know and love, but with some key
            improvements.
            <br></br>
            <br></br>
            In brief, there are 3 major changes.
          </Typography>
          <Typography variant='h4' sx={{ fontWeight: 'bold', mt: '3rem', mb: '1rem' }}>
            New Initiatives
          </Typography>
          <Typography variant='body1' sx={{ fontWeight: 'regular', mb: '1rem' }}>
            Get excited – we’re ramping up the quantity and quality of our initiatives! With two key objectives in mind
            (<b>networking for your business needs</b> and <b>building your founders’ support circle</b>), you can
            expect:
          </Typography>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: '1rem' }}>
            Current Initiatives:
          </Typography>
          <Typography variant='body1' sx={{ fontWeight: 'regular', mb: '1rem' }}>
            <ol>
              <li>Fortnightly Founders Dinner</li>
              <li>Fortnightly Teh Peng Club</li>
              <li>Trimonthly Summit Event</li>
            </ol>
          </Typography>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: '1rem' }}>
            New Initiatives:
          </Typography>
          <Typography variant='body1' sx={{ fontWeight: 'regular', mb: '1rem' }}>
            <ol>
              <li>Adhoc Problem-based Brainstorming Sessions</li>
              <li>Monthly Sports Sessions</li>
              <li>Monthly Drinking-Ranting Sessions</li>
              <li>Monthly Foodie Meetups</li>
              <li>Monthly Board Game Nights</li>
            </ol>
          </Typography>
          <Typography variant='body1' sx={{ fontWeight: 'regular', mb: '1rem' }}>
            Oh, and they’ll more than likely be physical meetups to ensure the most authentic and value-adding
            interactions! So, do keep a lookout for these exciting events lined up for you Hundreds.
          </Typography>
          <Typography variant='h4' sx={{ fontWeight: 'bold', mt: '3rem', mb: '1rem' }}>
            Mastermind Update
          </Typography>
          <Typography variant='body1' sx={{ fontWeight: 'regular', mb: '1rem' }}>
            We have always wanted physical meetings but realised from earlier trials that attendance will be a problem.
            As such, we’re introducing two things for the masterminds: physical sessions + strict attendance.
          </Typography>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: '1rem' }}>
            Physical Sessions:
          </Typography>
          <Typography variant='body1' sx={{ fontWeight: 'regular', mb: '1rem' }}>
            You can expect a physical dinner on the first meeting, with the option to meet physically for subsequent
            meetings. To facilitate this, you will be getting a local facilitator with founder experience.
          </Typography>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: '1rem' }}>
            Strict attendance:
          </Typography>
          <Typography variant='body1' sx={{ fontWeight: 'regular', mb: '1rem' }}>
            You can expect a group with higher consistency and group accountability - members who missed more than one
            session will be voted out by the group.
          </Typography>
          <Typography variant='h4' sx={{ fontWeight: 'bold', mt: '3rem', mb: '1rem' }}>
            Removing Inactive Members
          </Typography>
          <Typography variant='body1' sx={{ fontWeight: 'regular', mb: '1rem' }}>
            To further promote our goal of building a tight knit peer-to-peer community, we will be removing inactive
            members, as well as founders who are no longer actively working on their business.
            <br></br>
            <br></br>
            In doing so, we hope to do right by our active founders and provide them the support network they need to
            thrive in the founder’s marathon.
            <br></br>
            <br></br>
            <b>Our team will be personally reaching out in the coming week to notify you if you are affected. </b>
          </Typography>
        </Box>
      </Grid>
    </Fragment>
  );
};

export default RelaunchPage;
